import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { LocalAuthService } from './local-auth.service';
import { TrackJsService } from '../services/track-js.service';
import { StaffRoles } from './tokens';
import { UserwayService } from '../services/userway.service';
import { catchError, of, switchMap } from 'rxjs';

/**
 * Combo authentication and authorization route guard.  If no roles are specified, defaults to require role fullsite
 * @param allowedRoles roles required to activate the route.  Defaults to ft if no roles provoded
 * @param options groupOperator: determines whether to run and/or with the roles.  Defaults to or
 * @returns 
 */
export const authGuard = (allowedRoles: StaffRoles[] = ['fullsite'], options?: { groupOperator?: "or" | "and", selfAccessRouteParam?: string, userIds?: number[] }): CanActivateFn => {



  return (route, state) => {
    const authService = inject(LocalAuthService)
    const router = inject(Router)
    const trackJs = inject(TrackJsService)


    //functions defined for logic resuse.  Included inside the main authGuard functionso we don't have to pass around our injections.

    function authError() {
      const reason = authService.getLoggedInFailureReason();
      trackJs.consoleWarn('[Auth] Guard: loggedIn false, clearing token and redirecting to login', { reason, attemptedUrl: state.url });

      authService.clearToken()
      router.navigate(["/login"], { skipLocationChange: true, queryParams: { returnRoute: state.url } })

      return false;
    }

    function checkRoles(): boolean {
      //check roles
      let allowed = false

      if (!options?.groupOperator || options?.groupOperator === "or") {
        allowed = authService.hasAnyRole(allowedRoles)
      }
      else if (options?.groupOperator === "and") {
        allowed = authService.hasAllRoles(allowedRoles)
      }

      if (options?.selfAccessRouteParam) {
        allowed = allowed || authService.currentUser?.newstaffId === Number(route.params[options.selfAccessRouteParam])
      }

      // Check specific user IDs
      if (options?.userIds && !allowed) {
        allowed = authService.hasStaffId(options.userIds)
      }

      if (allowed) {
        return true
      }
      else {
        router.navigate(["/not-allowed"], { skipLocationChange: true, state: { allowedRoles: allowedRoles, groupOperator: options?.groupOperator ?? "or" } })
        return false
      }
    }
//************************** END FUNCTIONS *********************************** */


    if (!authService.loggedIn) {
      //If we aren't logged in, see if we have a refresh token we can use.
      if (!authService.isRefreshTokenExpired()) {
       return authService.refreshLogin().pipe(
        switchMap((token) => {
          return of(checkRoles())
        }),
        catchError(() => {
          return of(authError())
        })
       )
      }
      else {
        return of(authError())
      }
    }
    else {
      return of(checkRoles())
    }

  }



}
